class MetricManager {
  constructor(data) {
    this.data = data;
    this.consultation_completed = data.consultation_completed;
    this.total_chat_consultation = data.total_chat_consultation;
    this.total_call_consultation = data.total_call_consultation;
    this.total_consultation_time = data.total_consultation_time;
    this.average_consultation_time = data.average_consultation_time;
    this.average_wait_time = data.average_wait_time;
  }

  apiResponse = () => {
    return this.data;
  };
}

export default MetricManager;
